export default "__VITE_ASSET__Bw$NmnfC__"